// src/components/layout/Topbar.js
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Bell, Search, Wifi, WifiOff } from 'lucide-react';
import api from '../../utils/api';

const PAGE_TITLES = {
  '/dashboard': 'Dashboard',
  '/clients': 'Clienți',
  '/users': 'Utilizatori',
  '/hosting': 'Hosting',
  '/monitor': 'Monitorizare Live',
  '/reports': 'Rapoarte & Analiză',
  '/calendar': 'Calendar',
  '/settings': 'Setări',
  '/themes': 'Teme',
  '/module-manager': 'Manager Module',
};

export default function Topbar({ wsConnected, notifCount }) {
  const { user } = useAuth();
  const location = useLocation();
  const [showNotifs, setShowNotifs] = useState(false);
  const [notifs, setNotifs] = useState([]);

  const title = PAGE_TITLES[location.pathname] || 'CRM Modular';

  const loadNotifs = async () => {
    try {
      const { data } = await api.get('/notifications');
      setNotifs(data);
    } catch {}
  };

  const markRead = async () => {
    try { await api.put('/notifications/read'); } catch {}
  };

  return (
    <header style={{
      height: 60, background: 'var(--bg-secondary)', borderBottom: '1px solid var(--border)',
      display: 'flex', alignItems: 'center', padding: '0 20px', gap: 16, position: 'sticky', top: 0, zIndex: 50,
    }}>
      <div style={{ flex: 1 }}>
        <h1 style={{ fontSize: 17, fontWeight: 700 }}>{title}</h1>
      </div>

      {/* WS indicator */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: wsConnected ? 'var(--success)' : 'var(--text-secondary)' }}>
        {wsConnected ? <Wifi size={14} /> : <WifiOff size={14} />}
        {wsConnected ? 'Live' : 'Offline'}
      </div>

      {/* Notifications */}
      <div style={{ position: 'relative' }}>
        <button className="btn-icon" onClick={() => { setShowNotifs(!showNotifs); loadNotifs(); markRead(); }}
          style={{ position: 'relative' }}>
          <Bell size={18} />
          {notifCount > 0 && (
            <span style={{ position: 'absolute', top: -4, right: -4, background: 'var(--danger)', color: 'white', fontSize: 10, fontWeight: 700, borderRadius: '50%', width: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {notifCount > 9 ? '9+' : notifCount}
            </span>
          )}
        </button>
        {showNotifs && (
          <>
            <div style={{ position: 'fixed', inset: 0, zIndex: 99 }} onClick={() => setShowNotifs(false)} />
            <div style={{ position: 'absolute', right: 0, top: 36, width: 320, background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', boxShadow: 'var(--shadow)', zIndex: 100, overflow: 'hidden' }}>
              <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', fontWeight: 600, fontSize: 14 }}>Notificări</div>
              {notifs.length === 0 ? (
                <div style={{ padding: 24, textAlign: 'center', color: 'var(--text-secondary)', fontSize: 13 }}>Nicio notificare</div>
              ) : (
                <div style={{ maxHeight: 320, overflowY: 'auto' }}>
                  {notifs.map(n => (
                    <div key={n.id} style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)33', background: n.is_read ? 'transparent' : 'var(--accent)0a' }}>
                      <div style={{ fontSize: 13, fontWeight: 500 }}>{n.title}</div>
                      {n.message && <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 2 }}>{n.message}</div>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>

      {/* User avatar */}
      <div style={{ width: 32, height: 32, background: 'var(--accent)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: 'white', cursor: 'pointer' }}>
        {user?.full_name?.[0] || user?.username?.[0] || '?'}
      </div>
    </header>
  );
}
